import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { UrlPath } from "../../../../config/routeConfig";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../../shared/topBar/TopBar";
import { LoadingScreen } from '../../../UiComponents/LoadingComponent';
import { getUniverseListAction } from '../../../actions/universeListAction';
import { exportToExcelUsingRef } from "../../../utils/excelExporter";
import download from '../../../../Images/download.svg';
import { setActiveMenu, setActiveSubMenu } from "../../../actions/CommonAction";
import { ToastContainer } from "react-toastify";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
import { deleteUniverse,getCustomSettings } from "../../../../config/apiConfig";
import { SBGrid } from "../../../UiComponents/SBAAGgrid";
export const UniverseList = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const Gstate = useSelector(state => state); 
    const universeListData = Gstate.AnalyticsReporting.universeList;
    const universeListLoading = Gstate.AnalyticsReporting.universeListLoading;
    const isEditable = Gstate.authorizationData.isEditable;
    const gridApi = useRef();
    const [toDeleteUniverse,setToDeleteUniverse]=useState(null);
    const [modalShow, setModalShow] = useState(false)
    const [render,setRender]=useState(false);
    const [colDef, setColDef] = useState();
    const [appliedFilter, setAppliedFilter] = useState(null);
   
    useEffect(() => {
        document.title = `Universe List`;
        fetchGridData();
     },[])
    useEffect(() => { dispatch(getUniverseListAction()); }, [render]);
    const defaultColDef = {
        sortable: true, filter: true, flex: 1, floatingFilter: true,
    };
    const getDateFormatted = (params) => {
        const isoDate = params.value;
        const formattedDate = moment(isoDate).format('MM-DD-YYYY');
        return formattedDate;
    };
    const universeNameHyperLink = (params) => {
        const memberID = params.data.UniverseId;
        return <>
            <Link to={`${UrlPath.UniverseMembers}${memberID}`} onClick={() => dispatch(setActiveSubMenu(6, 12003))}>{params.value} </Link>
        </>
    }
    const newuniverseclick = () => {
        history(`${UrlPath.UniverseAdd}`);
    }

    const ActionsRenderer = (props) => {
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable])
        const universeId = props.data.UniverseId;
        const navigateUniverseEdit = () => {
            history(`${UrlPath.UniverseEdit}${universeId}`);
        }
        const deleteUniverse = () => {
            setModalShow(true);
            setToDeleteUniverse(universeId);
        }
        return (
            <div className="actions-cell">
                <i className={"fas fa-edit"} style={{ color: (isEdit !== false) ?"#47A547":"#808080", margin: "0 8px", cursor: "pointer" }} onClick={() => { isEditable && navigateUniverseEdit() }}></i>
                <i className={ "fa fa-trash"} style={{ color: (isEdit !== false) ?"#DF001B":"#808080", margin: "0 8px", cursor: "pointer" }} onClick={() => { isEditable && deleteUniverse()  }} ></i>
            </div>
        )
    }
    const deleteSelectedUniverse=()=>{
        console.log(toDeleteUniverse);
        sbaAxios({
            url:`${deleteUniverse}${toDeleteUniverse}`,
            method:'get'
        }).then(response=>{
            SBNotify({Msg:'Universe has been deleted successfully',type:'success'});
            setTimeout(()=>{
            setRender(!render);
            fetchGridData();
            },1000)
        }).catch(error=>{
            SBNotify({Msg:'Universe has not been deleted',type:'error'});
        })
        setModalShow(false);
    }
    const columnDefs = [
        { field: "UniverseName", headerName: "Universe Name", sort: 'asc', pinned: 'left', width: 400, filter: 'agTextColumnFilter', cellRenderer: universeNameHyperLink },
        { field: "UniverseDescription", headerName: "Universe Description", pinned: 'left', cellStyle: { border: 'none' } },
        { field: "MaxReturnRange", headerName: "Max Return Range" },
        { field: "CommonReturnRange", headerName: "Common Return Range" },
        { field: "CreatedByUserName", headerName: " CreatedBy" },
        { field: "CreatedDate", headerName: "Created Date", valueFormatter: getDateFormatted },
        { field: "Action", headerName: "Action", cellRenderer: ActionsRenderer, maxWidth: 100 }
    ];

    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1009}` });
            if (response) {

                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    valueFormatter: ["CreatedDate"].includes(item.colId) ? getDateFormatted : null,
                    cellRenderer: (item.colId === "UniverseName"
                            ? universeNameHyperLink:  item.colId === "Action"?ActionsRenderer
                            : " "

                        ),
                        "headerName": item.colId === "CreatedByUserName" ? "CreatedBy" :null,
                }));
                return { columns: formattedDef, filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };


    const Level = [{ BreadCrumb: "Universe", Routes: `${UrlPath.UniverseList}` }];

    return <div id="universeList">
        <TopBar label={'Universe List'} />
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid mainContentData">
            <div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="submit" className="p-sm-btn mx-1" onClick={newuniverseclick} disabled={!isEditable}><i className="fa-solid fa-plus" />Add</button>
                    <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(gridApi, "Universe List.xlsx") }}><img src={download} alt="" />Export</button>
                </div>
            </div>
            <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                {universeListLoading ?
                    <><LoadingScreen /></> :
                    // <AgGridReact
                    //     columnDefs={columnDefs}
                    //     rowData={universeListData}
                    //     defaultColDef={defaultColDef}
                    //     pagination={true}
                    //     paginationPageSize={20}
                    //     onGridReady={params => {
                    //         gridApi.current = params.api;
                    //     }}
                    // >
                    // </AgGridReact>
                    <SBGrid ref={gridApi} column={colDef} row={universeListData} filters={appliedFilter} componentID={1009} gridStyle={{ width: '100%', height: '70vh' }}></SBGrid>

                    }
            </div>
        </div >
        <Modal show={modalShow}  >
            <Modal.Header closeButton onClick={() => setModalShow(false)}>
                <Modal.Title>Do you want to delete the selected Universe ?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The selected Universe will be deleted permanently. Are you sure?</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={() => setModalShow(false)} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={deleteSelectedUniverse} disabled={!isEditable} >
                    Yes
                </button>
            </Modal.Footer>
        </Modal>
        <ToastContainer />
    </div>
}